import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, Component, Optional } from "@angular/core";
import { NzButtonGroupComponent } from "ng-zorro-antd/button";

@Component({
  selector: "ui-button-group",
  exportAs: "uiButtonGroup",
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UiButtonGroupComponent extends NzButtonGroupComponent {
  constructor(@Optional() directionality: Directionality) {
    super(directionality);
  }
}
